module.exports = __webpack_public_path__ + "static/media/financebanner@3x.3f336456.png";